export default function Loader() {
	return (
		<div className="cfs-talk-list-loader">
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
}
